var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/path.js
// module id = lCww
// module chunks = 04af